import { graphql } from 'react-relay';

export const PermissionCheckAddCommentQuery = graphql`
	query PermissionCheckAddCommentQuery($contentId: ID!) {
		content(id: $contentId, status: ["draft", "current"]) {
			nodes {
				id
				type
				operations {
					operation
					targetType
				}
			}
		}
	}
`;
